// Module
var code = "<div id=\"wrapper\" block-ui=\"main\"> <sticky-header></sticky-header> <div class=\"container\" ui-view></div> <sticky-footer id=\"sticky-bottom\"></sticky-footer> </div> ";
// Exports
module.exports = code;